import SegmentDetailed from './SegmentDetailed';
export default SegmentDetailed;
